import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements AfterViewInit  {
  products: any;
  searchString = '';
  timer: any;
  addProducts = 15;
  showedAll = false;
  loadingProducts: boolean = false;
  autoProductSearch: any = null;

  inputSearchProductsOff = true;
  tutorial = true;
  isInputFocused: boolean = false;

  @ViewChild('searchInput') searchInput!: ElementRef;

  constructor(
    private apiService: ApiService,
    private route: Router,
    private matDialog: MatDialog
    ) { }

  ngOnInit(){
    this.loadProducts();
  }

  ngAfterViewInit(){
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    }, 300);
  }

  onInputBlur(){
    this.inputSearchProductsOff = true;
    setTimeout(() =>{
      this.isInputFocused = false;
    }, 500)

  }
  async loadProducts(){
    this.products = await this.apiService.loadProducts();
  }

  onEnter(event: any){
    if (event.keyCode === 13) {
      event.preventDefault();
      if(this.loadingProducts && this.autoProductSearch == null){
        let timeOut = 10000;
        let retryTime = 200;

        let currentTime = 0;

        this.autoProductSearch = setInterval(() => {
          console.log('interval)')
          if (this.products && this.loadingProducts == false){
            clearInterval(this.autoProductSearch);
            this.autoProductSearch = null;
            if(this.products.length == 1){
              this.goToProductDetail(this.products[0].slug ? this.products[0].slug : this.products[0].codPro);
              this.matDialog.closeAll();
            }
          }
          currentTime += retryTime
          if(currentTime > timeOut){
            clearInterval(this.autoProductSearch);
            this.autoProductSearch = null;
          }
        }, retryTime)
      } else {
        if(this.products && this.products.length == 1){
          this.goToProductDetail(this.products[0].slug ? this.products[0].slug : this.products[0].codPro);
          this.matDialog.closeAll();
        }
      }
    }

  }

  searchProducts() {
    if(this.searchString.length <= 1){
      this.apiService.loadProductsFilter().subscribe(
        res => {
          this.products = this.apiService.filterProducts(res, '');
        }
      );
      return
    }
    this.apiService.loadProductsFilter().subscribe(
      lista => {
       this.products = this.apiService.filterProducts(lista, this.searchString);

      }
    );
  }
  goToProductDetail(param: string){
    this.route.navigate([`produto-detalhe/${param}`]);
    if(this.route.url == `/produto-detalhe/${param}`){
      this.route.navigate([`produto-detalhe/${param}`]);
    }
  }
  onKeyDownEvent(event: any){
    this.showedAll = false;
    clearTimeout(this.timer);


    this.timer = setTimeout(() => {
      this.searchString = event.target.value;
      this.searchProducts();
  }, 500);

    // this.searchProducts(event.target.value);
  }

  onFocus(){
    this.isInputFocused = true;
  }

  addProductsFiltered(){
    if(this.products.length > this.addProducts + 1){
      this.addProducts = this.addProducts + 15;
    } else {
      this.addProducts = this.products.length - 1;
      this.showedAll = true;
    }
  }

}
